module.exports = __webpack_public_path__ + "media/lifeIsWet.2e8a5f43.mp4";